import React, { useState, useRef } from 'react'
import cx from 'classnames'
import { AutoSizer, List } from 'react-virtualized'

import IconText from './IconText'
import DROPDOWNS from '@constants/Dropdowns'
import { useOutsideAlerter } from '@hooks'

const Dropdown = ({
  className,
  position,
  style,
  action,
  data,
  filter,
  listItemHeight,
  full,
  listItemsVisible = 3.2,
  dark,
  children,
  list,
  listProps,
  listClassname,
  triggerFocusedClassname,
  ...props
}) => {
  const wrapper = useRef(null)
  const [showContent, setShowContent] = useState(false)
  const positionShape =
    DROPDOWNS.POSITION[position.replace(' ', '_').toUpperCase()]

  data = data.filter(filter)
  const height = full
    ? listItemHeight * data.length
    : data.length < 3
    ? Math.max(data.length * listItemHeight, listItemHeight)
    : listItemHeight * listItemsVisible

  useOutsideAlerter(wrapper, () => setShowContent(false))

  return (
    <div
      className={cx('ui gp-dropdown', className, position, action, {
        dark,
        'with-content': showContent
      })}
      style={style}
      ref={wrapper}
    >
      {action === 'focus' ? (
        children
      ) : (
        <div
          className={cx('trigger', {
            [triggerFocusedClassname]: showContent && triggerFocusedClassname
          })}
          onClick={() => {
            setShowContent((showContent) => !showContent)
          }}
        >
          {children}
        </div>
      )}

      <div
        className={`ui gp-list gp-shape shape-${positionShape} ${
          list ? '' : 'border'
        } ${listClassname || ''}`}
        {...listProps}
        style={{ height: list ? height : 'auto' }}
        {...(action === 'focus' ? { tabIndex: 0 } : {})}
      >
        {list ? (
          <AutoSizer>
            {({ width }) => {
              return (
                <List
                  height={height}
                  width={width}
                  rowHeight={listItemHeight}
                  rowRenderer={({ index, key, style }) => {
                    const v = data[index]

                    return (
                      <div
                        className={`ui item theme theme-${
                          dark ? 'f' : 'a'
                        } interactive`}
                        key={key}
                        style={style}
                        onClick={(event) => {
                          setShowContent(false)
                          props.onchoose(v, key, event)
                          if (action === 'focus') document.activeElement.blur()
                        }}
                      >
                        <props.listItem {...props.listItemProps} {...v} />
                      </div>
                    )
                  }}
                  rowCount={data.length}
                  className='overflow'
                  {...(action === 'focus' ? { tabIndex: null } : {})}
                />
              )
            }}
          </AutoSizer>
        ) : (
          <div onClick={() => setShowContent(false)}>{props.content}</div>
        )}
      </div>
    </div>
  )
}

Dropdown.defaultProps = {
  className: '',
  style: {},

  data: [],
  action: 'hover',
  position: 'left top',
  listProps: {},
  listItem: IconText,
  listItemHeight: 40,
  full: false,
  listItemProps: {},
  onchoose: (item, key, event) => [item, key, event],
  filter: (el) => el,
  list: true
}

export default Dropdown
